<template>
    <div class="nav-content-wrapper" v-if="!$store.state.waitingRequest">
        <admin-navbar />
        
        <div class="content">    
            <h2>Mettre des jeux en avant</h2>
            
            <table border="1">
                <tr>
                    <th>Titre</th>
                    <th>Image</th>
                    <th>Vues</th>
                    <th>Date de mise en avant</th>
                    <th>Modifier</th>
                </tr>
                <tr v-for="game in featuredGames" :key="game.id">
                    <td>{{ game.title }}</td>
                    <td><img :src="'/games/static/miniatures/'+game.image_url"></td>
                    <td>{{ game.view_count }}</td>
                    <td>{{ game.featured_at }}</td>
                    <td><router-link :to="'featureGame/'+game.id"><i class="fas fa-edit"></i></router-link></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import Session from '../mixins/adminSession';
    import AdminNavbar from '../views/AdminNavbar';

    export default {
        name: 'AdminFeatureGames',
        mixins: [Session],
        components: {
            'admin-navbar': AdminNavbar
        },
        data() {
            return {
                featuredGames: []
            }
        },
        methods: {
            getFeaturedGames() {
                let formData = new FormData();
                formData.append('data', JSON.stringify({post: "1"}));
                
                axios
                .post(
                this.$store.state.apiUrl+"?request=getFeaturedGames", formData
                )
                .then((response) => {
                    if(response.data.length > 0) {
                        this.featuredGames = response.data;
                    }
                });
            }
        },
        mounted() {
            this.getFeaturedGames();
        }
    }
</script>

<style scoped src="@/assets/admin.css">
</style>
